import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaGooglePlay, FaAppStoreIos } from 'react-icons/fa';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';

import Login from '../components/login/Login';
import LoginLeftSidePage from '../components/login/LoginLeftSidePage';
import Const from '../util/Constants';
import withRouter from '../util/WithRouter';
import LoginAPI from '../api/LoginAPI';
import Util from '../util/Util';
import ApiUiController from '../controller/ApiUiController';

import '../components/login/Login.css';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isValidated: false, isAttempted: false, noAttemps: 0, inApiCall: false };
  }

  componentDidMount() {
    if (reactLocalStorage.get(Const.LoggedIn) === Const.STrue) this.props.navigate('/');
  }

  checkCredentials = (username, password) => {
    this.setState({ ...this.state, inApiCall: true });
    LoginAPI.login( username, password, this.onResponse, this.failure, this.props.logout);
  };

  failure = res => { this.setState({ ...this.state, inApiCall: false }); Util.showError(res); }

  onResponse = response => {
    reactLocalStorage.set(Const.LoggedIn, Const.STrue);
    reactLocalStorage.set(Const.Token, response.auth);
    reactLocalStorage.set(Const.System, response.system);
    let code = response.user.default_code;
    response.user.default_code = code !== undefined ? code : "+91";
    reactLocalStorage.setObject(Const.LoggedInUser, response.user);

    Notification.requestPermission();
    firebase.messaging().getToken().then(token => {
      if(token) LoginAPI.regToken(token, () => this.props.navigate('/'),
          () => this.props.navigate('/'));
      else this.onNotificationFailure(token);
    }).catch(err => { console.log(err); this.onNotificationFailure(); } );
  };

  onNotificationFailure = () => {
    Util.showNotification('Notification','Please Allow notification','danger');
    this.props.navigate("/");
  }

  render() {
    return (
      <div className="view-container ">
        <section
          id="content"
          className="content_login"
          data-ng-view=""
          style={{ left: 0 }}
        >
          <div className="ng-scope">
            <div className="container-fluid">
              <div className="row">
                <LoginLeftSidePage />

                <div
                  className="col-md-4 login-window"
                  style={{ backgroundImage: "url(/images/admin-2.png)" }}
                >
                  <div className="login_panel">
                    <div id="helpTour pullRight">
                      <div className="appicon">
                        <a
                          className="android"
                          href="https://play.google.com/store/apps/details?id=com.orggencrm.sales"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          <FaGooglePlay />{" "}
                        </a>
                        <a
                          className="ios"
                          href="https://apps.apple.com/jm/app/ogcrm-sales/id1561035015"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          <FaAppStoreIos />{" "}
                        </a>
                        <a
                          href="http://ogcrm.com/help/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="support-div pullRight">
                            Support : +91 9136390992
                          </span>
                        </a>
                      </div>
                    </div>
                    <h2>Login</h2>
                    <ApiUiController inApiCall={this.state.inApiCall}>
                      <div className="login-form">
                        <section className="logo text-center">
                          <img
                            className=" client_logo_login_logout"
                            src={process.env.PUBLIC_URL + "/images/logo.png"}
                            style={{ height: 36 + "px", width: 98 + "px" }}
                            alt="Logo"
                          />
                          <sup />
                        </section>
                        <div className="signin-body margin-top">
                          <div className="form-container">
                            <form className="form-horizontal ng-pristine ng-valid">
                              <Login validate={this.checkCredentials} />
                            </form>
                          </div>
                        </div>
                      </div>
                    </ApiUiController>
                    <div className="form-group power-row">
                      <div className="">
                        <span className="copyright hidden-xs">© 2021 </span>
                        <a target="_blank" rel="noreferrer" href="http://www.orggen.com">
                          OrgGen Technologies
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default withRouter(LoginPage);
